export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  author: string;
  readTime: string;
  category: string;
  categorySlug: string;
  tags: string[];
}

export const dramaArticles: ArticleItem[] = [
  {
    id: 'japan-anime-summer-2026',
    title: '2026夏番日漫推荐：十部必追新番，京都动画新作领衔',
    excerpt: '夏季新番盛宴来袭！从热血战斗到治愈日常，我们为你精选了十部不可错过的日漫新作，京都动画时隔三年的回归之作更是万众期待...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20illustration%20with%20beautiful%20summer%20scenery%2C%20cherry%20blossoms%2C%20warm%20sunlight%2C%20soft%20pastel%20colors%2C%20anime%20background%20art%2C%20clean%20composition&width=800&height=450&seq=cat-drama-01&orientation=landscape',
    date: '2026-08-07',
    author: '动漫编辑室',
    readTime: '12分钟',
    category: '影视',
    categorySlug: 'drama',
    tags: ['日漫', '新番', '京都动画'],
  },
  {
    id: 'j-drama-first-love-2',
    title: '《First Love 初恋》第二季制作决定！满岛光×佐藤健再度携手',
    excerpt: 'Netflix大热日剧《First Love 初恋》正式宣布制作第二季！满岛光和佐藤健将继续出演，寒竹百合导演回归执导...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20drama%20winter%20scene%2C%20couple%20in%20snowy%20street%2C%20nostalgic%20warm%20lighting%2C%20Hokkaido%20landscape%2C%20cinematic%20photography%2C%20emotional%20tone&width=800&height=450&seq=cat-drama-02&orientation=landscape',
    date: '2026-08-09',
    author: '日剧速报',
    readTime: '6分钟',
    category: '影视',
    categorySlug: 'drama',
    tags: ['日剧', 'First Love', 'Netflix'],
  },
  {
    id: 'k-drama-queen-of-tears-2',
    title: '《眼泪女王》确认制作第二季！金秀贤×金智媛有望再度合作',
    excerpt: 'tvN创下收视纪录的现象级韩剧《眼泪女王》确定续订第二季！朴智恩编剧正在创作剧本，主演阵容有望全员回归...',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20elegant%20couple%20in%20luxury%20modern%20setting%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20premium%20production%20aesthetic&width=800&height=450&seq=cat-drama-03&orientation=landscape',
    date: '2026-08-07',
    author: '韩剧研究所',
    readTime: '5分钟',
    category: '影视',
    categorySlug: 'drama',
    tags: ['韩剧', '眼泪女王', '金秀贤'],
  },
  {
    id: 'ghibli-new-film',
    title: '宫崎骏新作《风之轨迹》定档2027年春季，手绘动画再临',
    excerpt: '吉卜力工作室正式公布宫崎骏导演最新长篇动画电影《风之轨迹》，将回归全手绘制作，讲述一个关于风与记忆的奇幻故事...',
    image: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20animation%20art%20with%20lush%20green%20landscape%2C%20floating%20islands%2C%20soft%20dreamy%20clouds%2C%20warm%20golden%20sunlight%2C%20hand-drawn%20anime%20aesthetic%2C%20whimsical%20atmosphere&width=800&height=450&seq=cat-drama-04&orientation=landscape',
    date: '2026-08-05',
    author: '动漫编辑室',
    readTime: '8分钟',
    category: '影视',
    categorySlug: 'drama',
    tags: ['宫崎骏', '吉卜力', '动画电影'],
  },
  {
    id: 'squid-game-3',
    title: '《鱿鱼游戏》第三季杀青！黄东赫导演透露最终季规模史无前例',
    excerpt: 'Netflix全球现象级韩剧《鱿鱼游戏》第三季（最终季）已杀青，黄东赫导演在采访中透露本季制作规模达到了前两季的总和...',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20mysterious%20game%20set%20with%20colorful%20geometric%20patterns%2C%20dramatic%20lighting%2C%20suspenseful%20atmosphere%2C%20clean%20modern%20production%20design%2C%20cinematic%20composition&width=800&height=450&seq=cat-drama-05&orientation=landscape',
    date: '2026-08-04',
    author: '韩剧研究所',
    readTime: '7分钟',
    category: '影视',
    categorySlug: 'drama',
    tags: ['鱿鱼游戏', 'Netflix', '韩剧'],
  },
  {
    id: 'j-movie-godzilla-minus-2',
    title: '《哥斯拉-1.0》续集正式定名，山崎贵导演再度掌镜',
    excerpt: '斩获奥斯卡最佳视觉效果奖的日本电影《哥斯拉-1.0》确定制作续集，暂定名《哥斯拉-2.0》，山崎贵导演将携原班人马回归...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20kaiju%20movie%20cinematic%20scene%20with%20dramatic%20destruction%20and%20smoke%2C%20dark%20atmospheric%20lighting%2C%20intense%20mood%2C%20professional%20movie%20poster%20aesthetic%2C%20warm%20orange%20glow&width=800&height=450&seq=cat-drama-06&orientation=landscape',
    date: '2026-08-03',
    author: '电影情报站',
    readTime: '5分钟',
    category: '影视',
    categorySlug: 'drama',
    tags: ['哥斯拉', '日本电影', '山崎贵'],
  },
];

export const musicArticles: ArticleItem[] = [
  {
    id: 'bts-2026-comeback',
    title: 'BTS 2026 完整体回归！新专辑《WINGS OF DAWN》全球同步上线',
    excerpt: '时隔两年，BTS以完整体重磅回归，新专辑融合电子与古典元素，首日即打破多项纪录，主打歌MV三小时破亿...',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20boy%20band%20concert%20stage%20performance%20with%20dramatic%20lighting%2C%20golden%20and%20coral%20color%20scheme%2C%20grand%20scale%2C%20professional%20music%20photography%2C%20atmospheric%20fog&width=800&height=450&seq=cat-music-01&orientation=landscape',
    date: '2026-08-08',
    author: '韩流观察员',
    readTime: '8分钟',
    category: '音乐',
    categorySlug: 'music',
    tags: ['BTS', 'K-POP', '回归'],
  },
  {
    id: 'twice-world-tour-seoul',
    title: 'TWICE 首尔演唱会座无虚席，世界巡演正式启程',
    excerpt: 'TWICE在首尔奥林匹克公园KSPO DOME开启世界巡演首站，全场座无虚席，九位成员带来近三小时的精彩表演...',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20girl%20group%20concert%20with%20cheering%20fans%20and%20colorful%20stage%20lights%2C%20energetic%20performance%2C%20large%20venue%2C%20warm%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=cat-music-02&orientation=landscape',
    date: '2026-08-09',
    author: '韩流观察员',
    readTime: '6分钟',
    category: '音乐',
    categorySlug: 'music',
    tags: ['TWICE', '演唱会', 'K-POP'],
  },
  {
    id: 'japan-music-fes-2026',
    title: 'SUMMER SONIC 2026 完整阵容公布：YOASOBI、Official髭男dism领衔',
    excerpt: '日本最大夏季音乐节SUMMER SONIC 2026公布完整演出阵容，YOASOBI、Official髭男dism、King Gnu等顶级艺人确认参演...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20music%20festival%20outdoor%20main%20stage%20with%20crowd%2C%20summer%20atmosphere%2C%20colorful%20decorations%2C%20sunny%20day%2C%20festival%20energy%2C%20warm%20golden%20light&width=800&height=450&seq=cat-music-03&orientation=landscape',
    date: '2026-08-08',
    author: '音乐情报局',
    readTime: '7分钟',
    category: '音乐',
    categorySlug: 'music',
    tags: ['SUMMER SONIC', 'YOASOBI', '音乐节'],
  },
  {
    id: 'newjeans-tokyo-dome',
    title: 'NewJeans 东京巨蛋公演追加确定，日韩同步直播',
    excerpt: '大势女团NewJeans宣布将在东京巨蛋举办公演，因预售火爆紧急追加一场，并将通过日韩多家平台进行同步直播...',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20girl%20group%20youthful%20dreamy%20concept%20stage%2C%20pastel%20color%20lighting%2C%20soft%20atmosphere%2C%20vibrant%20performance%2C%20professional%20music%20photography%2C%20clean%20composition&width=800&height=450&seq=cat-music-04&orientation=landscape',
    date: '2026-08-07',
    author: '韩流观察员',
    readTime: '5分钟',
    category: '音乐',
    categorySlug: 'music',
    tags: ['NewJeans', '东京巨蛋', 'K-POP'],
  },
  {
    id: 'aimer-new-album',
    title: 'Aimer 全新原创专辑《星屑のダイアローグ》10月发行',
    excerpt: '日本实力派歌手Aimer宣布将于10月发行第六张原创专辑，收录包括多首动画主题曲在内的12首新曲，并公布全国巡演计划...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20female%20singer%20atmospheric%20concert%20with%20star%20night%20theme%2C%20soft%20blue%20and%20golden%20lighting%2C%20emotional%20mood%2C%20professional%20music%20photography%2C%20dreamy%20ambiance&width=800&height=450&seq=cat-music-05&orientation=landscape',
    date: '2026-08-06',
    author: '音乐情报局',
    readTime: '4分钟',
    category: '音乐',
    categorySlug: 'music',
    tags: ['Aimer', 'J-POP', '专辑'],
  },
  {
    id: 'seventeen-follow-tour',
    title: 'SEVENTEEN《FOLLOW》巡演追加亚洲场次，中国站有望落地',
    excerpt: 'SEVENTEEN世界巡演《FOLLOW》在首尔、东京场次全部售罄后，官方宣布追加亚洲场次，中国粉丝期待已久的国内站或将成真...',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20large%20boy%20group%20synchronized%20dance%20performance%20on%20stage%2C%20dramatic%20lighting%2C%20powerful%20energy%2C%20professional%20concert%20photography%2C%20warm%20coral%20tones&width=800&height=450&seq=cat-music-06&orientation=landscape',
    date: '2026-08-05',
    author: '韩流观察员',
    readTime: '5分钟',
    category: '音乐',
    categorySlug: 'music',
    tags: ['SEVENTEEN', '巡演', 'K-POP'],
  },
];

export const varietyArticles: ArticleItem[] = [
  {
    id: 'k-variety-earth-arcade-3',
    title: '《地球游乐厅3》重磅回归！原班人马再聚首，笑点密集升级',
    excerpt: '罗英锡PD操刀的现象级综艺第三季来了！原班人马李恩智、MIMI、李泳知、安宥真全员回归，首期前往泰国录制...',
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20colorful%20fun%20set%20with%20game%20props%2C%20bright%20studio%20lighting%2C%20playful%20atmosphere%2C%20entertainment%20production%20design%2C%20warm%20vibrant%20colors&width=800&height=450&seq=cat-variety-01&orientation=landscape',
    date: '2026-08-06',
    author: '综艺情报局',
    readTime: '6分钟',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['地球游乐厅', '罗英锡', '综艺'],
  },
  {
    id: 'running-man-700-episode',
    title: '《Running Man》700期特辑：历代最强嘉宾阵容齐聚',
    excerpt: '韩国最长寿综艺《Running Man》迎来700期！节目组精心策划特辑，邀请历年人气嘉宾回归，创下本年度最高收视...',
    image: 'https://readdy.ai/api/search-image?query=Korean%20Running%20Man%20variety%20show%20cast%20outdoor%20group%20photo%2C%20bright%20sunny%20day%2C%20casual%20colorful%20outfits%2C%20fun%20energetic%20vibe%2C%20entertainment%20photography&width=800&height=450&seq=cat-variety-02&orientation=landscape',
    date: '2026-08-08',
    author: '综艺情报局',
    readTime: '5分钟',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['Running Man', '700期', '韩综'],
  },
  {
    id: 'terrace-house-return',
    title: '《TERRACE HOUSE》重启确认！Netflix联手富士电视台打造新季',
    excerpt: '经典日本恋爱实境秀《TERRACE HOUSE》正式确认重启！Netflix与富士电视台联合制作，将在全新的城市展开新的故事...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20modern%20luxury%20house%20interior%20with%20large%20windows%2C%20minimalist%20design%2C%20warm%20natural%20light%2C%20cozy%20atmosphere%2C%20reality%20show%20setting%2C%20clean%20aesthetic&width=800&height=450&seq=cat-variety-03&orientation=landscape',
    date: '2026-08-05',
    author: '日综速递',
    readTime: '6分钟',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['TERRACE HOUSE', '日综', 'Netflix'],
  },
  {
    id: 'knowing-bros-500',
    title: '《认识的哥哥》500期：全员女装特辑笑翻全场',
    excerpt: 'JTBC王牌综艺《认识的哥哥》迎来500期，哥哥们全员挑战女装造型，嘉宾IU惊喜登场，创下节目年度最高收视率...',
    image: 'https://readdy.ai/api/search-image?query=Korean%20variety%20show%20school%20classroom%20set%2C%20colorful%20decorations%2C%20entertaining%20atmosphere%2C%20bright%20lighting%2C%20TV%20studio%20production%2C%20fun%20playful%20vibe&width=800&height=450&seq=cat-variety-04&orientation=landscape',
    date: '2026-08-04',
    author: '综艺情报局',
    readTime: '5分钟',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['认识的哥哥', '韩综', 'JTBC'],
  },
  {
    id: 'documental-season-15',
    title: '《Documental》第15季：松本人志钦点十位搞笑艺人巅峰对决',
    excerpt: 'Amazon Prime Video王牌搞笑节目《Documental》第15季正式上线，松本人志精选十位日本顶级搞笑艺人，密闭空间内展开终极较量...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20comedy%20show%20closed%20room%20setting%20with%20dramatic%20spotlight%2C%20intense%20atmosphere%2C%20professional%20TV%20production%2C%20dark%20warm%20lighting%2C%20serious%20yet%20playful%20mood&width=800&height=450&seq=cat-variety-05&orientation=landscape',
    date: '2026-08-03',
    author: '日综速递',
    readTime: '6分钟',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['Documental', '松本人志', '日综'],
  },
  {
    id: 'i-live-alone-special',
    title: '《我独自生活》十周年：彩虹会员齐聚济州岛特辑',
    excerpt: 'MBC人气观察综艺《我独自生活》迎来十周年纪念，全体彩虹会员前往济州岛展开三天两夜的特别旅行，精彩内容不容错过...',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Jeju%20Island%20coastal%20scenery%20with%20warm%20sunset%2C%20Korean%20variety%20show%20outdoor%20setting%2C%20peaceful%20atmosphere%2C%20nature%20landscape%2C%20travel%20vibe%2C%20golden%20hour%20photography&width=800&height=450&seq=cat-variety-06&orientation=landscape',
    date: '2026-08-02',
    author: '综艺情报局',
    readTime: '5分钟',
    category: '综艺',
    categorySlug: 'variety',
    tags: ['我独自生活', '韩综', '济州岛'],
  },
];

export const newsArticles: ArticleItem[] = [
  {
    id: 'kpop-global-market-2026',
    title: 'K-POP全球市场规模突破150亿美元，中国市场增长最为迅猛',
    excerpt: '据最新行业报告显示，K-POP全球市场规模在2026年第二季度突破150亿美元大关，中国市场同比增长45%领跑全球...',
    image: 'https://readdy.ai/api/search-image?query=Global%20Kpop%20music%20industry%20data%20visualization%20abstract%2C%20colorful%20infographic%20style%2C%20modern%20business%20aesthetic%2C%20warm%20coral%20and%20golden%20tones%2C%20clean%20professional%20design&width=800&height=450&seq=cat-news-01&orientation=landscape',
    date: '2026-08-09',
    author: '行业观察',
    readTime: '7分钟',
    category: '资讯',
    categorySlug: 'news',
    tags: ['K-POP', '市场', '产业'],
  },
  {
    id: 'hybe-sm-merger-update',
    title: 'HYBE与SM娱乐整合加速，2027年将推出超级联合企划',
    excerpt: 'HYBE与SM娱乐的深度整合进入新阶段，双方宣布将在2027年推出一项超级联合企划，涉及旗下多位顶级艺人...',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20headquarters%20building%20architecture%2C%20clean%20minimalist%20design%2C%20professional%20atmosphere%2C%20warm%20natural%20lighting%2C%20business%20photography%2C%20premium%20aesthetic&width=800&height=450&seq=cat-news-02&orientation=landscape',
    date: '2026-08-08',
    author: '行业观察',
    readTime: '8分钟',
    category: '资讯',
    categorySlug: 'news',
    tags: ['HYBE', 'SM', '产业'],
  },
  {
    id: 'japan-anime-industry-2026',
    title: '日本动画产业2026上半年产值创历史新高，海外市场占比首超六成',
    excerpt: '日本动画协会发布2026年上半年产业报告，总产值达到1.8万亿日元，海外市场收入占比首次突破60%，中国市场贡献最大...',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20industry%20illustration%20with%20colorful%20art%20style%2C%20creative%20studio%20environment%2C%20animation%20production%20scene%2C%20warm%20lighting%2C%20artistic%20atmosphere%2C%20professional%20workspace&width=800&height=450&seq=cat-news-03&orientation=landscape',
    date: '2026-08-07',
    author: '产业速报',
    readTime: '6分钟',
    category: '资讯',
    categorySlug: 'news',
    tags: ['动画产业', '日本', '市场'],
  },
  {
    id: 'netflix-korea-investment',
    title: 'Netflix宣布未来四年在韩投资25亿美元，加大原创内容制作',
    excerpt: 'Netflix CEO在首尔记者会上宣布，未来四年将在韩国市场投资25亿美元，用于制作更多韩剧、电影和无脚本综艺内容...',
    image: 'https://readdy.ai/api/search-image?query=Streaming%20platform%20corporate%20event%20press%20conference%20modern%20setting%2C%20professional%20stage%20with%20brand%20logos%2C%20clean%20corporate%20aesthetic%2C%20warm%20lighting%2C%20business%20atmosphere&width=800&height=450&seq=cat-news-04&orientation=landscape',
    date: '2026-08-06',
    author: '产业速报',
    readTime: '5分钟',
    category: '资讯',
    categorySlug: 'news',
    tags: ['Netflix', '韩国', '投资'],
  },
  {
    id: 'tokyo-film-festival-2026',
    title: '第39届东京国际电影节公布主竞赛单元入围名单',
    excerpt: '第39届东京国际电影节正式公布主竞赛单元入围名单，共有15部来自全球各地的优秀影片入围，其中包括3部日韩合拍作品...',
    image: 'https://readdy.ai/api/search-image?query=International%20film%20festival%20red%20carpet%20event%2C%20elegant%20venue%20with%20warm%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20professional%20event%20photography%2C%20cinema%20aesthetic&width=800&height=450&seq=cat-news-05&orientation=landscape',
    date: '2026-08-05',
    author: '电影情报站',
    readTime: '4分钟',
    category: '资讯',
    categorySlug: 'news',
    tags: ['东京电影节', '电影', '日本'],
  },
  {
    id: 'korean-streaming-war',
    title: '韩国流媒体大战：TVING与Wavve合并谈判重启，Coupang Play异军突起',
    excerpt: '韩国本土流媒体市场格局生变，TVING与Wavve重启合并谈判以对抗Netflix，而Coupang Play凭借电商生态异军突起...',
    image: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20on%20multiple%20devices%2C%20digital%20entertainment%20concept%2C%20clean%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography&width=800&height=450&seq=cat-news-06&orientation=landscape',
    date: '2026-08-04',
    author: '产业速报',
    readTime: '6分钟',
    category: '资讯',
    categorySlug: 'news',
    tags: ['流媒体', '韩国', 'TVING'],
  },
];

export const allCategoryArticles: Record<string, ArticleItem[]> = {
  drama: dramaArticles,
  music: musicArticles,
  variety: varietyArticles,
  news: newsArticles,
};

export const categoryMeta = {
  drama: { name: '影视', icon: 'ri-movie-2-line', description: '最新日韩电视剧、电影、动漫推荐与深度解析' },
  music: { name: '音乐', icon: 'ri-music-2-line', description: 'J-POP、K-POP最新动态、专辑评测与演唱会资讯' },
  variety: { name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门日韩综艺、真人秀最新内容与幕后花絮' },
  news: { name: '资讯', icon: 'ri-newspaper-line', description: '日韩娱乐产业最新动态、行业分析与深度报道' },
};